import type { AccordionData } from "@/design-system/Molecules/AccordionList/Accordion.types";
import React from "react";

const faqPairs: [string, React.ReactNode][] = [
  [
    "What are Trimix injections?",
    <>
      <p>
        Trimix injections deliver potent ingredients directly to the penis for
        greater effect. Male patients report powerful erections that start
        within 15 minutes and last up to an hour.
      </p>
      <br />
      <p>
        Trimix injections often provide results when oral medications like
        sildenafil fail. If you've tried other medications that didn’t work, or
        you’d prefer a faster and more reliable ED solution, ED injections may
        be right for you.
      </p>
    </>,
  ],
  [
    "How do I access a Trimix prescription?",
    <>
      <p>
        Because Trimix is more potent than oral ED medication, we require a few
        steps to ensure you have a positive experience.
      </p>
      <br />
      <p>
        A licensed medical practitioner will review your health questionnaire to
        ensure you don’t have any contraindications (reasons not to take
        Trimix). Then, we have you watch instructional videos to ensure you
        understand how to inject Trimix safely.
      </p>
    </>,
  ],
  [
    "What makes Trimix effective?",
    <>
      <p>
        The active ingredients in Trimix perform similar functions to
        medications like Sildenafil and Tadalafil. They help relax smooth muscle
        and expand blood vessels, which is crucial for healthy erections.
      </p>
      <br />
      <p>
        The difference is, Trimix is injected directly into the penis for faster
        and more intense onset of action. This is why Trimix can be effective
        for men with treatment resistant ED. Men may also prefer Trimix because
        its effects start in around 5-15 minutes.
      </p>
    </>,
  ],
  [
    "How do I inject Trimix?",
    <>
      Before you order Trimix, we’ll provide you with three training videos.
      These videos will teach you how to mix Trimix (since it ships
      freeze-dried), how to inject, and how to avoid a condition called
      priapism.
    </>,
  ],
  [
    "Can I get more information about Trimix?",
    <>
      <ul className="list-disc pl-8 mt-0 mb-4 space-y-1 text-gray-600">
        <li>Pharmacy information</li>
        <li>Trimix Mixing Instructions</li>
        <li>Trimix Injection Instructions</li>
        <li>Priapism</li>
      </ul>
    </>,
  ],
];
export const trimixFaqData: AccordionData[] = faqPairs.map(
  ([question, answer]) => ({
    question,
    answer,
  })
);
